// File: assets/sync-n-sell.js

(function() {
    var SyncNSell = {
      totalQuantity: 0,
      addedEmails: 0,
  
      init: function(totalQuantity) {
        this.totalQuantity = totalQuantity;
        this.bindEvents();
      },
  
      bindEvents: function() {
        document.getElementById('addUserDetails').addEventListener('click', this.addUserDetails.bind(this));
      },
  
      validateEmail: function(email) {
        var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(String(email).toLowerCase());
      },
  
      addUserDetails: function(event) {
        event.stopPropagation();
        
        if (this.addedEmails >= this.totalQuantity) {
          document.getElementById('emailLimitMessage').style.display = 'block';
          return false;
        }
        
        var name = document.getElementById('learnerName').value;
        if(!name) return false;
  
        var email = document.getElementById('learnerEmail').value;
        if(!email || !this.validateEmail(email)) return false;
  
        var learners = document.getElementById('learners');
        var li = document.createElement('li');
        li.innerHTML = `<b>${name}</b> ${email}`;
        
        learners.appendChild(li);
  
        document.getElementById('learnerName').value = '';
        document.getElementById('learnerEmail').value = '';
  
        var userDetails = document.getElementById('userDetails').value;
        document.getElementById('userDetails').value = userDetails + `${name}:${email};`;
        
        this.addedEmails++;
        
        if (this.addedEmails >= this.totalQuantity) {
          document.getElementById('emailLimitMessage').style.display = 'block';
          document.getElementById('addUserDetails').style.display = 'none';
        }
        
        return false;
      }
    };
  
    window.SyncNSell = SyncNSell;
  })();